
import React from 'react';
import { X } from 'lucide-react';
import { Input } from '../ui/input';

interface ImagePreviewProps {
  preview: string;
  keywords: string;
  onRemove: () => void;
  onKeywordsChange: (keywords: string) => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  preview,
  keywords,
  onRemove,
  onKeywordsChange,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent form submission
    }
  };

  return (
    <div className="space-y-2">
      <div className="relative group hover-scale">
        <img
          src={preview}
          alt="Preview"
          className="w-full h-40 object-cover rounded-lg"
        />
        <button
          onClick={onRemove}
          className="absolute top-2 right-2 p-1 bg-white/80 rounded-full 
                   opacity-0 group-hover:opacity-100 transition-opacity
                   hover:bg-red-50"
        >
          <X className="w-4 h-4 text-red-500" />
        </button>
      </div>
      <Input
        placeholder="Enter keywords for this image"
        value={keywords}
        onChange={(e) => onKeywordsChange(e.target.value)}
        onKeyDown={handleKeyDown}
        className="text-sm"
      />
    </div>
  );
};
